import requiredFieldConfigRaw from '../../data/requiredFieldConfig';
import LoanValidationRenderer from './LoanValidationRenderer';

const FeeValidate = () => {
    const config = requiredFieldConfigRaw.Pages.find(p => p.Page === 'Order Smart Fees');
    return <LoanValidationRenderer pageName="Order Smart Fees" config={config} redirectPage="Service Orders" />;
};

export default FeeValidate;